import { Accounting, Angularjs, Chicago, Commission, ComputerSoftware, Contract, FinancialServices, Frontenddesigner, Fulltime, GraphicDesigner, GulpPug, ITEngineer, Internship, Javascript, NewYork, Nodejs, PHPdeveloper, Parttime, ReactDeveloper, SanFrancisco, Seattle, Serviceindustry, Temporary, UIUxdesigner, Washington, htmlcss } from "../../Constant";

export const CHECKBOX_DATA = [
  {
    inputTittle: Fulltime,
    inputNumber: "(8688)",
  },
  {
    inputTittle: Contract,
    inputNumber: "(503)",
  },
  {
    inputTittle: Parttime,
    inputNumber: "(288)",
  },
  {
    inputTittle: Internship,
    inputNumber: "(236)",
  },
  {
    inputTittle: Temporary,
    inputNumber: "(146)",
  },
  {
    inputTittle: Commission,
    inputNumber: "(25)",
  },
];

export const LOCATION_CHECKBOX_DATA = [
  {
    location: NewYork,
    locationSpanText: "NY (399)",
  },
  {
    location: SanFrancisco,
    locationSpanText: "CA (252)",
  },
  {
    location: Washington,
    locationSpanText: "DC (226)",
  },
  {
    location: Seattle,
    locationSpanText: "WA (242)",
  },
  {
    location: Chicago,
    locationSpanText: "IL (187)",
  },
];

export const JOB_TITLE_DATA = [
  {
    JobTitle: UIUxdesigner,
    JobNumber: 25,
  },
  {
    JobTitle: GraphicDesigner,
    JobNumber: 10,
  },
  {
    JobTitle: Frontenddesigner,
    JobNumber: 15,
  },
  {
    JobTitle: PHPdeveloper,
    JobNumber: 42,
  },
  {
    JobTitle: ReactDeveloper,
    JobNumber: 5,
  },
];

export const INDUSTRY_DATA = [
  {
    industryTitle: ComputerSoftware,
    industryNumber: 14,
  },
  {
    industryTitle: ITEngineer,
    industryNumber: 10,
  },
  {
    industryTitle: Serviceindustry,
    industryNumber: 20,
  },
  {
    industryTitle: Accounting,
    industryNumber: 34,
  },
  {
    industryTitle: FinancialServices,
    industryNumber: 5,
  },
];

export const SKILL_CHECKBOX_DATA = [htmlcss, Javascript, Nodejs, GulpPug, Angularjs];

export const JOB_DATA = [
  {
    id: 1,
    logo: "job-search/1.jpg",
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City",
    job_city: "UT",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    type: "new",
    ribbion: false,
  },
  {
    id: 2,
    logo: "job-search/2.jpg",
    job_name: "React/React Native Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "San Diego",
    job_city: "CA",
    Job_description: "Insipidity the sufficient discretion imprudence decisively. Proceed how visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    type: "new",
    ribbion: false,
  },
  {
    id: 3,
    logo: "job-search/3.jpg",
    job_name: "Senior UX designer",
    job_area: "Minneapolis",
    job_city: "MN",
    Job_description: "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was.",
    type: "2 days ago",
    ribbion: true,
  },
  {
    id: 4,
    logo: "job-search/4.jpg",
    job_name: "Front end web developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    Job_description: "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to. Doubtful yet way properly answered.",
    type: "3 days ago",
    ribbion: false,
  },
  {
    id: 5,
    logo: "job-search/5.jpg",
    job_name: "Graphic designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    type: "3 days ago",
    ribbion: false,
  },
  {
    id: 6,
    logo: "job-search/6.jpg",
    job_name: "Designer, CRM",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    Job_description: "You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards. The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment.",
    type: "5 days ago",
    ribbion: false,
  },
  {
    id: 7,
    logo: "job-search/2.jpg",
    job_name: "React/React Native Developer",
    job_area: "San Diego",
    job_city: ",CA",
    Job_description: "We are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role.",
    type: "5 days ago",
    ribbion: true,
  },
  {
    id: 8,
    logo: "job-search/3.jpg",
    job_name: "Senior UX designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Minneapolis",
    job_city: "MN",
    Job_description: "3+ years of experience working in as a Frontend Engineer or comparable role. we are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team.",
    type: "5 days ago",
    ribbion: false,
  },
  {
    id: 9,
    logo: "job-search/5.jpg",
    job_name: "Graphic designer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Infosys",
    job_city: "Lelystad, Netherlands ",
    Job_description: "Insipidity the sufficient discretion imprudence resolution decisively. Proceed how visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
    type: "3 days Ago",
    ribbion: false,
  },
  {
    id: 10,
    logo: "job-search/1.jpg",
    job_name: "Designer, CRM",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Citrix",
    job_city: "Lelystad, Netherlands",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
    type: "3 days Ago",
    ribbion: false,
  },
  {
    id: 11,
    logo: "job-search/1.jpg",
    job_name: "UI/UX IT Frontend Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "(L6) Salt Lake City",
    job_city: "UT",
    Job_description: "We are looking for an experienced and koho designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating coely with other...",
    type: "new",
    ribbion: false,
  },
  {
    id: 12,
    logo: "job-search/2.jpg",
    job_name: "React/React Native Developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "San Diego",
    job_city: "CA",
    Job_description: "deally 2+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface",
    type: "new",
    ribbion: false,
  },
  {
    id: 13,
    logo: "job-search/4.jpg",
    job_name: "Front end web developer",
    badgeType: "primary",
    badgeValue: "New",
    job_area: "Cisco",
    job_city: "Lelystad, Netherlands",
    Job_description: "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards",
    type: "3 days ago",
    ribbion: false,
  },
  {
    id: 14,
    logo: "job-search/3.jpg",
    job_name: "Senior UX designer",
    badgeType: "secondary",
    badgeValue: "New",
    job_area: "Minneapolis",
    job_city: "MN",
    Job_description: "We are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role.",
    type: "2 days ago",
    ribbion: true,
  },
];

export const QUALIFICATION_DATA = ["Have shipped multiple iOS, Android, and/or web products ", "5+ years UI/UX experience", "Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles", "Ability to autonomously pursue elegant solutions to open-ended problems", "Comfort with ambiguity", "Lively work on more than one project at a time", "Experience conducting user research and stakeholder interviews", "Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.", "Bonus Considerations "];

export const AGENCY_EXP_DATA = ["Experience working with Agile development teams", "Experience with RITE method usability testing", "Experience in visual and motion design; ability to translate UX design into high quality visuals", "Mastery of Sketch & InVision", "Knowledge of mobile or front-end web programming"];

export const PEARKS_DATA = ["Competitive pay", "Competitive medical, dental, and vision insurance plans", "proviCompanyded 401(k) plan", "Paid vacation and sick time", "Free snacks and beverages"];
